import { FC, useState } from 'react';
import { IconInformation } from '../../../../../../../assets/DesignSystem/SVGComponents';
import { LoadingOutlined } from '@ant-design/icons';
import { updateConfirmEdition } from '../../../../../../../services/orders';
import { IReports, IUpdateConfirmEdition, REPORT_STATUS } from '../../../../../../../types/orders';
import { displaySuccessNotification } from '../../../../../../../utils/displayNudosStandardNotifications';
import './ComponentConfirmEdition.scss';

interface IComponentConfirmEdition {
  reports: IReports[];
  updateWithoutLoaders: () => void;
  shipmentId: number;
  editShipmentId?: number;
}

const ComponentConfirmEdition: FC<IComponentConfirmEdition> = ({
  reports,
  shipmentId,
  editShipmentId,
  updateWithoutLoaders
}: IComponentConfirmEdition) => {
  const [select, setSelect] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const updateStatus = async () => {
    const reportId = reports[0]?.id || editShipmentId;
    if (reportId) {
      const body: IUpdateConfirmEdition = {
        reportId: reportId,
        status: REPORT_STATUS.CLOSED,
        shipmentId: shipmentId,
        haveReport: !!reports[0]?.id
      };
      setLoading(true);
      try {
        setSelect(true);
        await updateConfirmEdition(body);
        await updateWithoutLoaders();
        displaySuccessNotification({
          customJSXMessage: <>Información marcada con éxito</>
        });
      } catch (error) {
        setSelect(false);
      } finally {
        setLoading(false);
      }
    }
  };

  if (loading)
    return (
      <div className="loaderContainer">
        <LoadingOutlined style={{ color: '#070F21', fontSize: 12 }} />
      </div>
    );

  return (
    <div id="componentConfirmEdition">
      <IconInformation color="#F00" />
      <div className="confirmText">Se actualizó la información de destino de esta orden</div>
      <div className="checkContainer" onClick={() => updateStatus()}>
        {select ? <div className="select"></div> : <div className="noSelect"></div>}
      </div>
      <div className="confirmGray">Entendido</div>
    </div>
  );
};

export default ComponentConfirmEdition;
